import { ILocation } from "@common/models/GeoLocation";
import { Culture } from "@core/Culture";
import Config from "@service/Config";
import { linkScriptToHeader } from "./Init";

export interface IBoundingCoordinate {
    neLat: number;
    neLng: number;
    swLat: number;
    swLng: number;
}

export const loadCountryWithIp = (): Promise<any> => {
    return new Promise((resolve, reject) => {
        fetch("https://ip2c.org/s", {
            method: "GET"
        })
            .then((response) => {
                resolve(response.text());
            })
            .catch((err) => {
                reject(err);
            })
    })
}

export function getBoundingCoordinates(location: ILocation, distance: number): IBoundingCoordinate {
    const earthRadius = 6371.01;
    const constant = Math.PI / 173;
    const latCoef = 365 / Math.PI;
    const lngCoef = 180 / Math.PI;
    const distanceInKilometers = distance * 0.6;
    const latRadian = (distanceInKilometers / earthRadius) * latCoef;
    const lngRadian = (distanceInKilometers / earthRadius) * lngCoef;
    // north east coordinate
    const neLat = location.lat + latRadian;
    const neLng = location.lng + lngRadian / Math.cos(location.lat * constant);
    // south west coordinate
    const swLat = location.lat - latRadian;
    const swLng = location.lng - lngRadian / Math.cos(location.lat * constant);

    return { neLat, neLng, swLat, swLng };
}

export function isInside(point: ILocation, vertices: ILocation[]): boolean {
    // northEast,southEast, southWest, northWest
    const sections = [0, 0, 0, 0];
    for (let i = vertices.length; i--;) {
        const index = getIndex(point, vertices[i]);
        ++sections[index];
    }
    for (let i = sections.length; i--;) {
        if (sections[i] === 0) { return false; }
    }
    return true;

    function getIndex(main: ILocation, vertix: ILocation) {
        if (vertix.lat > main.lat) {
            // north
            if (vertix.lng > main.lng) {
                // east
                return 0;
            }
            // west
            return 3;
        } else {
            // south
            if (vertix.lng > main.lng) {
                // east
                return 1;
            }
            return 2;
            // west
        }
    }
}

export async function getAddress(location: ILocation) {
    const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${location.lat}&lon=${location.lng}`);
    const details = await response.json();
    return ({
        city: details.address.city,
        // country: details.address.county ? details.address.county?.replace("County", "")?.trim() : details.address.province.replace("Province", "").trim(),
        countryCode: details.address.country_code.toUpperCase()
    });
}

export const setOriginCityName = async () => {
    const response = await fetch('https://geolocation-db.com/json/');
    const geoProperty = await response.json();
    const address = await getAddress({
        lat: geoProperty.latitude,
        lng: geoProperty.longitude
    });
    return address.city;
}

export function getTransferDuration(origin: ILocation, destination: ILocation, departureTime: number, arrivalTime?: number): Promise<google.maps.Duration> {
    return new Promise((resolve, reject) => {
        if ('google' in window) {
            apiCall();
        } else {
            linkScriptToHeader(`https://maps.googleapis.com/maps/api/js?key=${Config.get("gMapCode")}&libraries=places&callback=initMap&language=${Culture.getLocale().lang}`, apiCall, () => reject());
        }

        function apiCall() {
            const service = new google.maps.DistanceMatrixService();
            const matrix: google.maps.DistanceMatrixRequest = {
                avoidHighways: false,
                avoidTolls: false,
                destinations: [destination],
                drivingOptions: {
                    departureTime: new Date(departureTime),
                    trafficModel: google.maps.TrafficModel.PESSIMISTIC
                },
                origins: [origin],
                transitOptions: {
                    arrivalTime: arrivalTime ? new Date(arrivalTime) : undefined,
                    departureTime: new Date(departureTime)
                },
                travelMode: google.maps.TravelMode.DRIVING,
                unitSystem: google.maps.UnitSystem.METRIC
            };
            service.getDistanceMatrix(matrix, (response, status) => {
                if (status !== google.maps.DistanceMatrixStatus.OK) {
                    reject(status);
                } else {
                    resolve(response?.rows[0].elements[0].duration_in_traffic || {} as google.maps.Duration);
                }
            });
        }
    });
}
